module.exports = __webpack_public_path__ + "img/crying-face.5acf4416.gif";